import http from './http';

// 数据统计相关接口
export const statsApi = {
  // 获取统计数据
  getStats(params) {
    return http.get('/stats', { params });
  },
  // 获取图表数据
  getChartData(params) {
    return http.get('/stats/chart', { params });
  }
};

// VDM产品相关接口
export const vdmApi = {
  // 获取VDM产品列表
  getProductList(params) {
    return http.get('/vdm/list', { params });
  },
  // 获取VDM产品详情
  getProductDetail(prod_no) {
    return http.get(`/vdm/queryProduct/${prod_no}`);
  },
  // 提交VDM产品
  pushProduct(data) {
    return http.post('/vdm/pushProduct', data);
  },
  // 获取商品分类列表
  getGoodsCategoryList() {
    return http.get('/kkday_goods_cate/list');
  },
  // 获取城市列表
  getCityList() {
    return http.get('/city/list');
  }
};

// KKday商品相关接口
export const kkdayProductApi = {
  // 获取商品列表
  getList(params) {
    return http.get('/kkday_product/list', { params });
  },
  // 获取商品详情
  getDetail(prod_no) {
    return http.get(`/kkday_product/detail/${prod_no}`);
  },
  // 编辑商品
  edit(data) {
    return http.post('/kkday_product/edit', data);
  },
  // 删除商品
  delete(prod_no) {
    return http.post('/kkday_product/del', { prod_no });
  },
  // 获取套餐列表
  getPackagesList(prod_no) {
    return http.get(`/kkday_product/${prod_no}/packages/list`);
  },
  // 获取套餐详情
  getPackageDetail(prod_no, id) {
    return http.get(`/kkday_product/${prod_no}/packages/detail/${id}`);
  },
  // 编辑套餐
  editPackage(prod_no, id, data) {
    return http.post(`/kkday_product/${prod_no}/packages/${id}/edit`, data);
  },
  // 删除套餐
  deletePackage(prod_no, id) {
    return http.post(`/kkday_product/${prod_no}/packages/${id}/del`);
  },
  // 获取分类列表
  getCategoryList() {
    return http.get('/kkday_goods_cate/list');
  },
  // 获取城市列表
  getCityList() {
    return http.get('/city/list');
  },
  // 设置单个商品 Banner 状态
  setBanner(data) {
    return http.post('/kkday_product/set_banner', data);
  },
  // 设置单个商品推荐状态
  setRecommend(data) {
    return http.post('/kkday_product/set_recommend', data);
  },
  // 批量设置 Banner 状态
  batchSetBanner(data) {
    return http.post('/kkday_product/batch_banner', data);
  },
  // 批量设置推荐状态
  batchSetRecommend(data) {
    return http.post('/kkday_product/batch_recommend', data);
  },
  // 设置单个商品首页 Banner 状态
  setHomeBanner(data) {
    return http.post('/kkday_product/set_home_banner', data);
  },
  // 设置单个商品首页推荐状态
  setHomeRecommend(data) {
    return http.post('/kkday_product/set_home_recommend', data);
  },
  // 设置排序值
  setSort(data) {
    return http.post('/kkday_product/set_sort', data);
  }
};

// 旅游服务分类相关接口
export const travelCategoryApi = {
  // 获取分类列表
  getList() {
    return http.get('/travel_category/list');
  },
  // 获取分类详情
  getDetail(id) {
    return http.get(`/travel_category/detail/${id}`);
  },
  // 新增分类
  add(data) {
    return http.post('/travel_category/add', data);
  },
  // 修改分类
  edit(data) {
    return http.post('/travel_category/edit', data);
  },
  // 删除分类
  del(data) {
    return http.post('/travel_category/del', data);
  }
};

// Kkday订单相关接口
export const kkdayOrderApi = {
  // 获取订单列表
  getList(params) {
    return http.get('/vdm/order/list', { params });
  },
  // 获取订单详情
  getDetail(sn) {
    return http.get(`/vdm/order/show/${sn}`);
  },
  // 处理退款（旧接口，保留兼容）
  handleRefund(data) {
    return http.post('/vdm/order/refund', data);
  },
  // 处理退款（审核：批准或拒绝）
  processRefund(data) {
    return http.post('/vdm/order/refund/process', data);
  },
  // 查询退款状态
  getRefundStatus(sn) {
    return http.get('/vdm/order/refund/status', { params: { sn } });
  }
};

// 导出所有API
export default {
  stats: statsApi,
  vdm: vdmApi,
  kkdayProduct: kkdayProductApi,
  travelCategory: travelCategoryApi,
  kkdayOrder: kkdayOrderApi
};